// extracted by mini-css-extract-plugin
module.exports =  {"rating":"iGnz_vP","stars":"SdWiZDA","other-stars":"ExFMTBm","otherStars":"ExFMTBm","star":"X3b0SLD","rating-count":"MAoZB_U","ratingCount":"MAoZB_U"};